import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';

import { TranslationService } from 'app/core/internationalization/translation.service';
import { ModalService } from 'app/core/modals/services/modal.service';
import { DateFormats } from 'app/shared/constants/date-formats';
import { RecentActivityModel } from 'app/shared/models/recent-activity-models/recent-activity.model';
import { RecentActivityEventModel } from 'app/shared/models/recent-activity-models/recent-activity-event.model';
import { KhLocalizedDatePipe } from 'app/shared/pipes/kh-localized-date.pipe';
import {
  StudentQuestionAttemptModalComponent
} from 'app/student-question-attempt/student-question-attempt-modal/student-question-attempt-modal.component';
import { TEACHER_ROUTE } from 'app/teacher/routing-constants/teacher-routing.constant';

@Component({
  selector: 'kh-recent-activity-content',
  templateUrl: './recent-activity-content.component.html',
  styleUrls: ['./recent-activity-content.component.less'],
  standalone: false
})
export class RecentActivityContentComponent {
  private readonly router = inject(Router);
  private readonly _translationService = inject(TranslationService);
  private readonly modalService = inject(ModalService);
  private readonly localizedDatePipe = inject(KhLocalizedDatePipe);

  @Input() public classId = '';
  @Input() public recentActivityDays = 0;
  @Input() public isParentView = false;
  @Input() public hideActions = false;
  @Input() public isDemo = false;
  @Input() public isTeacher = true;
  @Input() public recentActivity: RecentActivityModel[] = [];

  public dateFormats = DateFormats;

  public async goToTeacherMissionReport(missionId: string): Promise<void> {
    const route = TEACHER_ROUTE.MISSION_REPORT.route(this.classId, missionId);
    await this.router.navigate(route);
  }

  public async goToTeacherGameShowReport(gameShowRunId: string): Promise<void> {
    const route = TEACHER_ROUTE.GAMESHOW_REPORT.route(this.classId, gameShowRunId);
    await this.router.navigate(route);
  }

  public viewAttempt(attemptId: string,
    itemOrder: number,
    hideActions: boolean): void {
    this.modalService.displayModal<StudentQuestionAttemptModalComponent>(StudentQuestionAttemptModalComponent, {
      attemptId: attemptId,
      itemOrder: itemOrder,
      isTeacher: this.isTeacher,
      hideActions: hideActions,
      isDemo: this.isDemo
    }, 'lg', true);
  }

  public getMissionEventTooltip(missionName: string, event: RecentActivityEventModel): string {
    return this._translationService.instant('RECENT_ACTIVITY_CONTENT.MISSIONNAME_BRANCHNAME_QUESTION_COUNT_DATE',
      {
        missionName: missionName,
        branchName: event.Branch?.Name ?? '',
        count: event.NumberOverride ? event.NumberOverride : event.QuestionNumber,
        date: this.getLocalizedDateRow(event.StartDate)
      });
  }

  public getSkillEventTooltip(event: RecentActivityEventModel): string {
    return this._translationService.instant('RECENT_ACTIVITY_CONTENT.BRANCHNAME_QUESTION_COUNT_DATE',
      {
        branchName: event.Branch?.Name ?? '',
        count: event.NumberOverride ? event.NumberOverride : event.ItemOrderInBranch,
        date: this.getLocalizedDateRow(event.StartDate)
      });
  }

  public getGameShowEventTooltip(gameShowName: string, event: RecentActivityEventModel): string {
    return this._translationService.instant('RECENT_ACTIVITY_CONTENT.GAMESHOWNAME_QUESTION_COUNT_DATE',
      {
        gameShowName: gameShowName,
        count: event.NumberOverride ? event.NumberOverride : event.AttemptItemOrder,
        date: this.getLocalizedDateRow(event.StartDate)
      });
  }

  private getLocalizedDateRow(date: string): string {
    return this.localizedDatePipe.transform(new Date(date), this.dateFormats.LT);
  }
}
